namespace $.$$ {
	
	$mol_style_define( $yuf_number_range, {

		Dec: {
			minHeight: '1.25rem',
			width: '1rem',
			justifyContent: 'center',
		},
		Inc: {
			minHeight: '1.25rem',
			width: '1rem',
			justifyContent: 'center',
		},

		flex: {
			grow: 11,
			shrink: 1,
		},
		minWidth: '8rem',
		justifyContent: 'space-between',
		alignItems: 'center',


	} )
	
}
